export default __webpack_public_path__ + "static/media/xlsSuccess.c37765e2.svg";